import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { TextComponent } from "../../../Components/TextComponent";
import { WidgetDesignTable } from "../Widgets/WidgetDesignTable";
import { app } from "../../../Frame/App";

export type PopupDesignTableComponentProps = {
    widget: WidgetDesignTable;
}

export class PopupDesignTableComponent extends JSXComponent {
    props: PopupDesignTableComponentProps;
    dropdown: DropDownComponent;
    markup: string;
    styles: string;
    layoutId: number;
    clientId: string;
    viewType: string;
    viewId: number;

    constructor(props: PopupDesignTableComponentProps) {
        super(props);

        this.markup = this.props.widget.props.markup;
        this.styles = this.props.widget.props.styles;
        this.clientId = this.props.widget.props.clientId;
        this.layoutId = this.props.widget.props.rowClickPageId;
        this.viewType = this.props.widget.props.viewType;
        this.viewId = this.props.widget.props.viewId;
    }

    onSave = (): boolean => {
        var selectedView = this.dropdown.getValue();

        this.props.widget.props.markup = this.markup;
        this.props.widget.props.styles = this.styles;
        this.props.widget.props.clientId = this.clientId;
        this.props.widget.props.rowClickPageId = this.layoutId;
        this.props.widget.props.viewType = this.viewType;
        this.props.widget.props.viewId = this.viewId;

        if (!isNaN(Number(selectedView))) {
            this.props.widget.props.viewId = parseInt(selectedView);
            this.props.widget.props.viewType = undefined;
        } else {
            this.props.widget.props.viewType = selectedView;
            this.props.widget.props.viewId = undefined;
        }

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;

    getElement = () => {

        this.element = <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetTable}>

            <div className="view-dropdown">
            </div>

            <TextComponent model={this} field="clientId" name={Resources["WidgetClient"].clientId} />
            <TextComponent model={this} restrictTo="integer" field="layoutId" name={Resources["WidgetClient"].layoutId} />

            {this.renderMarkupEditor()}

            <div style={{ height: "1rem" }}></div>

            {this.renderStylesEditor()}

        </DynPopup >;
    }

    createDropdown() {

        let items = [
            { name: Resources['WidgetClient'].massnahmenListe, value: "MassnahmenListe" },
            { name: Resources['WidgetClient'].meineMassnahmen, value: "MeineMassnahmen" },
            { name: Resources['WidgetClient'].meineZustaendig, value: "MeineZustaendig" }
        ];

        $.ajax({
            url: app.resolveUrl("~/api/tableView/getCockpitViews"),
            method: "GET",
            success: (response) => {
                if (Array.isArray(response)) {
                    for (let entry of response) {
                        items.push({ name: entry.text, value: entry.value });
                    }
                }

                this.renderDropdown(items);
            },
            error: (err) => {
                console.log(err);

                this.renderDropdown(items);
            }
        });
    }

    private renderDropdown = (items: any[]) => {
        let dropdownParent = this.element.querySelector(".view-dropdown") as HTMLElement;

        this.dropdown = new DropDownComponent({
            id: "popupTableListView",
            name: Resources['WidgetClient'].listView,
            displayProperty: "name",
            valueProperty: "value",
            addEmptyItem: true,
            items: items
        });
        dropdownParent.appendChild(this.dropdown.render());

        if (this.viewType) {
            this.dropdown.setValue(this.viewType);
        }

        if (this.viewId) {
            this.dropdown.setValue(this.viewId.toString());
        }
    }

    renderMarkupEditor(): HTMLElement {
        return <div className="markup-editor">
            <TextComponent model={this}
                field="markup"
                textarea={true}
                name={Resources["WidgetClient"].designHtml}
                lines={10}
            />
            <div className="info">
                {`Resources: Muss das element <div class="table-placeholder"></div> enthalten.`}
            </div>
        </div>;
    }

    renderStylesEditor(): HTMLElement {
        return <div className="styles-editor">
            <TextComponent model={this}
                field="styles"
                textarea={true}
                name={Resources["WidgetClient"].styles}
                lines={10}
            />
        </div>;
    }

    render(): HTMLElement {
        this.getElement();
        this.createDropdown();

        return this.element;
    }
}
